"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSanitizedPageUrl = exports.getSessionId = exports.getSafeUrl = exports.createNewSession = exports.getStatsigUser = exports.getPreExistingUser = exports.getStableID = exports.getRandomId = exports.getLocalValue = exports.setLocalValue = exports.shouldLogEvent = exports.getTargetNode = exports.getAnchorNodeInHierarchy = exports.gatherEventData = exports.debugLog = void 0;
var loggableElements = [
    'a',
    'button',
    'form',
    'input',
    'select',
    'textarea',
];
var globals = new Map();
var MAX_SESSION_IDLE_TIME = 10 * 60 * 1000; // 10 minutes
var MAX_SESSION_AGE = 4 * 60 * 60 * 1000; // 4 hours
function debugLog() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if ((_a = window === null || window === void 0 ? void 0 : window.statsig_wa) === null || _a === void 0 ? void 0 : _a.debug) {
        console.log.apply(console, args);
    }
}
exports.debugLog = debugLog;
function gatherEventData(target) {
    var tagName = target.tagName.toLowerCase();
    var metadata = new Map();
    var value = tagName;
    if (tagName === 'form') {
        metadata.set('action', target.getAttribute('action'));
        metadata.set('method', target.getAttribute('method') || 'GET');
        metadata.set('formName', target.getAttribute('name'));
        metadata.set('formId', target.getAttribute('id'));
    }
    if (['input', 'select', 'textarea'].includes(tagName)) {
        if (target.getAttribute('type') !== 'password') {
            metadata.set('content', target.value);
            metadata.set('inputName', target.getAttribute('name'));
        }
    }
    var anchor = getAnchorNodeInHierarchy(target);
    if (anchor) {
        metadata.set('href', anchor.getAttribute('href'));
    }
    if (tagName === 'button' || anchor) {
        metadata.set('content', (target.textContent || '').trim());
        var dataset = getDatasetProperties(anchor || target);
        dataset.forEach(function (value, key) {
            metadata.set(key, value);
        });
    }
    return { value: value, metadata: metadata };
}
exports.gatherEventData = gatherEventData;
function getDatasetProperties(el) {
    var dataset = el.dataset;
    var map = new Map();
    if (dataset) {
        for (var key in dataset) {
            map.set("data-".concat(key), dataset[key]);
        }
    }
    return map;
}
function getAnchorNodeInHierarchy(node) {
    if (!node) {
        return null;
    }
    var parent = node;
    while (parent) {
        var parentTagName = parent.tagName.toLowerCase();
        if (['body', 'document'].includes(parentTagName)) {
            return null;
        }
        if (parent.tagName.toLowerCase() === 'a') {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}
exports.getAnchorNodeInHierarchy = getAnchorNodeInHierarchy;
function getTargetNode(e) {
    if (!e) {
        return null;
    }
    var target = e.target || e.srcElement;
    if (!target) {
        return null;
    }
    if (target.nodeType === 3) {
        target = (target.parentNode || null);
    }
    return target;
}
exports.getTargetNode = getTargetNode;
function shouldLogEvent(e, el) {
    if (!e || !el || el.nodeType !== 1) {
        return false;
    }
    var tagName = el.tagName.toLowerCase();
    var eventType = e.type.toLowerCase();
    switch (tagName) {
        case 'html':
            return false;
        case 'form':
            return eventType === 'submit';
        case 'input':
        case 'select':
        case 'textarea':
            return ['change'].includes(eventType);
        default:
            if (eventType === 'click') {
                if (tagName === 'button') {
                    return true;
                }
                var anchor = getAnchorNodeInHierarchy(el);
                if (anchor) {
                    return true;
                }
            }
            return false;
    }
}
exports.shouldLogEvent = shouldLogEvent;
function setLocalValue(key, value) {
    if (window && window.localStorage) {
        window.localStorage.setItem(key, value);
    }
    else {
        globals.set(key, value);
        console.error('Statsig Web AutoCapture: No window.localStorage');
    }
}
exports.setLocalValue = setLocalValue;
function getLocalValue(key) {
    if (window && window.localStorage) {
        return window.localStorage.getItem(key);
    }
    return globals.get(key);
}
exports.getLocalValue = getLocalValue;
function getRandomId() {
    if (crypto && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    var s = function () { return Math.floor(Math.random() * 0x10000).toString(16).padStart(4, '0'); };
    return "".concat(s()).concat(s(), "-").concat(s(), "-4").concat(s().substring(1), "-").concat(s(), "-").concat(s()).concat(s()).concat(s());
}
exports.getRandomId = getRandomId;
function getStableID() {
    var key = 'STATSIG_LOCAL_STORAGE_STABLE_ID';
    var sid = getLocalValue(key);
    if (!sid) {
        sid = getRandomId();
        setLocalValue(key, sid);
    }
    return sid;
}
exports.getStableID = getStableID;
function getPreExistingUser() {
    var _a, _b;
    var statsigInstance = (_a = window === null || window === void 0 ? void 0 : window.statsig) === null || _a === void 0 ? void 0 : _a.instance;
    if (!statsigInstance) {
        statsigInstance = (_b = window === null || window === void 0 ? void 0 : window.Statsig) === null || _b === void 0 ? void 0 : _b.instance;
    }
    if (statsigInstance && statsigInstance.getCurrentUser) {
        return statsigInstance.getCurrentUser();
    }
    return null;
}
exports.getPreExistingUser = getPreExistingUser;
function getStatsigUser() {
    var _a, _b, _c, _d;
    var fragment = getPreExistingUser();
    if (!fragment) {
        var sid = getStableID();
        fragment = {
            customIDs: {
                stableID: sid,
                sessionID: getSessionId(),
            },
        };
    }
    var userOverride = (window === null || window === void 0 ? void 0 : window.statsigUser) || {};
    return __assign(__assign(__assign({}, fragment), userOverride), { custom: __assign(__assign(__assign({}, fragment.custom), userOverride.custom), { url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, page_url: (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.href, language: (_c = window === null || window === void 0 ? void 0 : window.navigator) === null || _c === void 0 ? void 0 : _c.language, useragent: (_d = window === null || window === void 0 ? void 0 : window.navigator) === null || _d === void 0 ? void 0 : _d.userAgent }) });
}
exports.getStatsigUser = getStatsigUser;
function createNewSession() {
    var now = Date.now();
    return {
        id: getRandomId(),
        startTime: now,
        lastAccessedTime: now,
    };
}
exports.createNewSession = createNewSession;
function getSafeUrl() {
    var _a;
    var href = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || '';
    var url;
    try {
        url = new URL(href);
    }
    catch (e) {
        url = new URL('error:');
    }
    return url;
}
exports.getSafeUrl = getSafeUrl;
function getSessionId() {
    var key = 'STATSIG_LOCAL_STORAGE_SESSION';
    var sessionJSON = getLocalValue(key);
    var session = null;
    var now = Date.now();
    try {
        session = JSON.parse(sessionJSON !== null && sessionJSON !== void 0 ? sessionJSON : 'null');
    }
    catch (e) {
    }
    if (!session ||
        !session.lastAccessedTime ||
        !session.startTime ||
        now - session.startTime > MAX_SESSION_AGE ||
        now - session.lastAccessedTime > MAX_SESSION_IDLE_TIME) {
        session = createNewSession();
    }
    session.lastAccessed = now;
    setLocalValue(key, JSON.stringify(session));
    return session.id;
}
exports.getSessionId = getSessionId;
function getSanitizedPageUrl() {
    var _a, _b;
    var url = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.split(/[?#]/)[0];
    return url || '';
}
exports.getSanitizedPageUrl = getSanitizedPageUrl;
